<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <div class="page-header">
                    <div class="page-title">
                        <h4>Draft Truck</h4>
                        
                    </div>
                    <div class="d-flex">
                        <!-- <div class="tabs">
                            <a routerLink="/truck-mapping" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }">All Orders</a>
                            <a routerLink="/orders/draft-order" routerLinkActive="active">Draft Order</a>
                        </div> -->
                        <a  *ngIf="accessControlService.canWrite('Common Upload')" class="btn btn-primary btn-sm ms-3" (click)="upload('/utility/upload',{ type: 'budget' })"> Upload Order</a>
                        <!-- *ngIf="accessControlService.canWrite('Budget')" -->
                        <button 
                         class="btn btn-primary btn-sm ms-3" (click)="addBudget('Add')" *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">+ Assemble New Truck</button>
                        <div class="col" style="padding-left: 0;">
                            <app-export-btn [selectedRows]="selectedRows" [allColumns]="columns" [fileName]="'Truck Fleet'" [exportApi]="getListExportApi"
                            [exportParams]="{ filters: filters, sortingCol: sortingCol, direction: direction }"></app-export-btn>
                        </div>                              
                    </div>
                </div>
                 <!-- STAT CARDS -->
        <div class="stats-row">
        <div class="stat-card">
            <div class="stat-icon si-blue">🚛</div>
            <div>
            <div class="stat-label">Total Trucks</div>
            <div class="stat-num">{{totalCount}}</div>
            <div class="stat-sub">All statuses</div>
            </div>
        </div>
        <div class="stat-card" routerLink="/truck-mapping">
            <div class="stat-icon si-green">✅</div>
            <div>
            <div class="stat-label">Live Trucks</div>
            <div class="stat-num">{{totalCount}}</div>
            <div class="stat-sub">Fully assembled &amp; submitted</div>
            </div>
        </div>
        <div class="stat-card" routerLink="/truck-mapping/draft-truck">
            <div class="stat-icon si-orange">📋</div>
            <div>
            <div class="stat-label">Drafts</div>
            <div class="stat-num">4</div>
            <div class="stat-sub">Pending completion</div>
            </div>
        </div>
        <div class="stat-card">
            <div class="stat-icon si-yellow">⚠️</div>
            <div>
            <div class="stat-label">Compliance Alerts</div>
            <div class="stat-num">1</div>
            <div class="stat-sub">Expiring within 30 days</div>
            </div>
        </div>
        </div>
                <!-- <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <app-filter (filterChange)="onFilterChange($event)" [orderNumber]="true" [orderStatus]="true" [DateofPlacement]="true" [showCustomer]="true" [showVendor]="false"
                                    (resetFilters)="onResetFilters()">
                                </app-filter>
                                <ng-container *ngIf="userType !=='VENDOR' && userType !=='ASSOCIATE'">
                                <ng-container *ngIf="selectedData[0]?.status == 'Draft' || selectedData[0]?.status == 'Created'">
                                <a class="btn btn-primary ml-3 mr-3" *ngIf="(selectedData?.length ?? 0) > 0" (click)="editEvent()">Edit</a>
                                </ng-container>
                                </ng-container>
                                <a *ngIf="selectedData.length == 1" class="btn btn-primary ml-3 mr-3" (click)="duplicateEvent()">Duplicate</a>
                                <a *ngIf="selectedData.length > 0" class="btn btn-primary ml-3 mr-3" (click)="deleteEvent()">Delete</a>
                            </div>

                        </div>

                        <app-shared-table [componentName]="'orders'" [columns]="columns" [tableName]="tableName" [data]="tableLists" [dropdownOptions]="dropdownOptions"
                            (sortChange)="onSortChange($event)" (selectedRowsChange)="onSelectedRowsChange($event)" (reloadEvent)="reloadEvent($event)">
                        </app-shared-table>


                    </div>
                    <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

                </div> -->


        <!-- TOP BAR -->
        <!-- <div class="topbar">
        <div class="topbar-left">
            <h1>Truck Fleet</h1>
            <p>View, manage and assemble all trucks in your fleet.</p>
        </div>
        <div class="topbar-right">
            <button class="btn btn-outline">↓ Export</button>
            <button class="btn btn-primary">+ Assemble New Truck</button>
        </div>
        </div> -->
<div class="card">
                    <div class="card-body">
       

        <!-- FILTER BAR -->
        <!-- <div class="filter-bar">
        <div class="filter-left">
            <button class="tab-btn active-live" onclick="setTab(this,'live')">
            <span class="tab-live-dot"></span> Live Trucks <span class="tab-count">118</span>
            </button>
            <button class="tab-btn" onclick="setTab(this,'draft')">
            <span class="tab-draft-icon">📋</span> Draft Trucks <span class="tab-count">24</span>
            </button>
        </div>
        <div class="filter-right">
            <div class="search-box">
            <span class="search-icon">🔍</span>
            <input type="text" placeholder="Search truck, model, dealer…" />
            </div>
            <button class="btn btn-outline btn-sm">⚙ Filters</button>
            <button class="btn btn-outline btn-sm">↕ Sort</button>
        </div>
        </div> -->

        <!-- BULK ACTION BAR -->
        <div class="bulk-bar" id="bulkBar">
            <app-filter (filterChange)="onFilterChange($event)"  [truckNumber]="true"  [truckBrand]="true" [truckModel]="true" [pollutionNumber]="true" [insuranceNumber]="true"
                (resetFilters)="onResetFilters()">
            </app-filter>

        <!-- <span class="bulk-selected">2 selected</span>
        <span class="bulk-label">Bulk actions:</span> -->
        <div class="bulk-actions">
            <button class="btn btn-primary btn-sm"  (click)="addComponentPopUp()" [disabled]="selectedRows.length === 0">+ Add Component</button>
            <button class="btn btn-primary btn-sm"  (click)="removeComponentPopUp()" [disabled]="selectedRows.length === 0">— Remove Component</button>
            <button class="btn btn-primary btn-sm"  [disabled]="true">⇄ Exchange Component</button>
        </div>
        <!-- <span class="bulk-close" onclick="document.getElementById('bulkBar').style.display='none'">✕</span> -->
        </div>



        <!-- TABLE -->
        <div class="table-wrap">
        <table>
            <thead>
            <tr>
                <th></th>
                <th (click)="sortData('truckNumber')">TRUCK NO <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th (click)="sortData('truckBrand')">BRAND <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th (click)="sortData('truckModel')">MODEL <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th>TYRES</th>
                <th>BATTERIES</th>
                <th (click)="sortData('pollutionNumber')">PUC <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th (click)="sortData('insuranceNumber')">INSURANCE <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th colspan="">VENDOR </th>
                <th (click)="sortData('createdAt')">ASSEMBLY DATE <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th (click)="sortData('updatedAt')">LAST MODIFIED <span class="svg-sort"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span></th>
                <th colspan="2">COMPONENT ADDED / REMOVED – KM READING </th>
            </tr>
            </thead>
            <tbody>

            <!-- ROW 1 — selected -->
            <tr class="" *ngFor="let item of tableLists">
                <td>
                    <!-- <input type="checkbox" class="cb"  /> -->
                <p-checkbox class="form-check-input"  [(ngModel)]="item.selected" (onChange)="onRowSelect(item)"
                [binary]="true"></p-checkbox></td>
                <td><a class="truck-link" (click)="openDetail(item?.id)">{{item?.truckNumber}}</a></td>
                <td><div class="brand-name"  (click)="openDetail(item?.id)">{{item?.truckBrand}}</div></td>
                <td><span class="type-tag">{{item?.truckModel}}</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>12/{{item?.tyreCapacity}}</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/{{item?.batteryCapacity}}</span></td>
                <td><span class="comp-date cd-ok">{{item?.pollutionNumber}}</span></td>
                <td><span class="comp-date cd-warn">{{item?.insuranceNumber}}</span></td>
                <td class="dealer-name">{{item?.vendorName}}<div class="dealer-code">{{item?.vendorCode}}</div></td>
                
                <td><div class="date-val">{{item?.createdAt | CustomDatePipe: 'D-M-YYYY'}}</div></td>
                <td><div class="date-val">{{item?.updatedAt | CustomDatePipe: 'D-M-YYYY'}}</div></td>
                <td colspan="2" class="event-list-main">
                    <div class="event-list">
                        <!-- <div class="draft-progress-wrap">
                            <div class="dp-bar-track"><div class="dp-bar-fill" style="width:40%"></div></div>
                            <div class="dp-label">40%</div>
                        </div>
                        <div class="dp-missing">Missing: Batteries, Compliance, Dealer</div> -->
                        <button class="btn btn-outline btn-sm"  (click)="editTruck(item)" style="width:100%;justify-content:center;border-color:#ea580c;color:#ea580c" onmouseover="this.style.background='#fff7ed'" onmouseout="this.style.background=''">▶ Resume Draft</button>
                        <!-- <div class="ev-more"  (click)="openDetail(item?.id)">View more events →</div> -->
                    </div>
                </td>
            </tr>

            <!-- ROW 2 — selected -->
            <tr class="d-none">
                <td><input type="checkbox" class="cb"  /></td>
                <td><a class="truck-link" (click)="openDetail(1)">TRK-2024-1031</a></td>
                <td><div class="brand-name">Ashok Leyland 3518</div></td>
                <td><span class="type-tag">32 FT SKL</span></td>
                <td><span class="comp-pill cp-orange"><span class="cp-dot"></span>10/12</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/2</span></td>
                <td><span class="comp-date cd-ok">✓ 20 Nov 2024</span></td>
                <td><span class="comp-date cd-ok">✓ 10 Dec 2024</span></td>
                <td class="dealer-name">Kapoor Trucks<div class="dealer-code">DLR-0041</div></td>
                
                <td><div class="date-val">05 Jan 2024</div></td>
                <td><div class="date-val">28 Jan 2024</div></td>
                <td colspan="2" class="event-list-main">
                <div class="event-list">
                    <div class="event-item ev-exchanged">
                    <div class="ev-badge">⇄ EXCHANGED · <span class="ev-serial">BAT-8841</span></div>
                    <div class="ev-meta">⚡ Battery · 15 Jan 2024<br>KM Reading: 1,800 km</div>
                    </div>
                    <div class="ev-more">+ 1 more event →</div>
                </div>
                </td>
            </tr>

            <!-- ROW 3 -->
            <tr class="d-none">
                <td><input type="checkbox" class="cb" /></td>
                <td><a class="truck-link" (click)="openDetail(2)">TRK-2024-0998</a></td>
                <td><div class="brand-name" ><a class="truck-link" (click)="openDetail(2)">TATA Prima 4028.S</a></div></td>
                <td><span class="type-tag">40 FT HXL</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>12/12</span></td>
                <td><span class="comp-pill cp-orange"><span class="cp-dot"></span>1/2</span></td>
                <td><span class="comp-expired">✕ Expired</span></td>
                <td><span class="comp-date cd-warn">⚡ 05 Mar 2024</span></td>
                <td class="dealer-name">Ravi Auto Works<div class="dealer-code">DLR-0041</div></td>
                
                <td><div class="date-val">18 Dec 2023</div></td>
                <td><div class="date-val">18 Dec 2023</div></td>
                <td colspan="2" class="event-list-main">
                <div class="event-list">
                    <div class="event-item ev-added">
                    <div class="ev-badge">+ ADDED · <span class="ev-serial">SN-9910</span></div>
                    <div class="ev-meta">⬤ Tyre · 18 Dec 2023<br>KM Reading: 0 km</div>
                    </div>
                    <div class="ev-more">+ 2 more events →</div>
                </div>
                </td>
            </tr>

            <!-- ROW 4 -->
            <tr class="d-none">
                <td><input type="checkbox" class="cb" /></td>
                <td><a class="truck-link">TRK-2023-0871</a></td>
                <td><div class="brand-name">Eicher Pro 6031</div></td>
                <td><span class="type-tag">24 FT SKL</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>8/8</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/2</span></td>
                <td><span class="comp-date cd-ok">✓ 30 Sep 2024</span></td>
                <td><span class="comp-date cd-warn">⚡ 15 Mar 2024</span></td>
                <td class="dealer-name">Sharma Motors<div class="dealer-code">DLR-0041</div></td>
                
                <td><div class="date-val">02 Oct 2023</div></td>
                <td><div class="date-val">14 Jan 2024</div></td>
                <td colspan="2" class="event-list-main">
                <div class="event-list">
                    <div class="event-item ev-removed">
                    <div class="ev-badge">− REMOVED · <span class="ev-serial">SN-6064</span></div>
                    <div class="ev-meta">⬤ Tyre · 14 Jan 2024<br>KM Reading: 22,400 km</div>
                    </div>
                    <!-- <div class="event-item ev-added">
                    <div class="ev-badge">+ ADDED · <span class="ev-serial">SN-5521</span></div>
                    <div class="ev-meta">⬤ Tyre · 14 Jan 2024<br>KM Reading: 22,400 km</div>
                    </div> -->
                </div>
                </td>
            </tr>

            <!-- ROW 5 -->
            <tr class="d-none"  >
                <td><input type="checkbox" class="cb" /></td>
                <td><a class="truck-link">TRK-2023-0764</a></td>
                <td><div class="brand-name">Mahindra Blazo X 40</div></td>
                <td><span class="type-tag">40 FT MXL2</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>12/12</span></td>
                <td><span class="comp-pill cp-green"><span class="cp-dot"></span>2/2</span></td>
                <td><span class="comp-date cd-ok">✓ 12 Aug 2024</span></td>
                <td><span class="comp-date cd-ok">✓ 22 Oct 2024</span></td>
                <td class="dealer-name">National Fleet Co<div class="dealer-code">DLR-0041</div>.</td>
                
                <td><div class="date-val">14 Jul 2023</div></td>
                <td><div class="date-val">14 Jul 2023</div></td>
                <td colspan="2">
                <div class="ev-none">No component changes since assembly</div>
                </td>
            </tr>

            <!-- ROW 6 — DRAFT -->
            <!-- <tr style="background:#fffbeb"> -->
            <tr class="d-none"> 
                <td><input type="checkbox" class="cb" /></td>
                <td>
                <a class="truck-link">TRK-2024-1055</a>
                <span class="draft-tag">▶ DRAFT</span>
                </td>
                <td><div class="brand-name">BharatBenz 3523R</div></td>
                <td><span class="type-tag">32 FT SKL</span></td>
                <td><span class="comp-pill cp-orange"><span class="cp-dot"></span>4/12</span></td>
                <td><span class="comp-pill cp-red"><span class="cp-dot"></span>0/2</span></td>
                <td><span class="comp-date cd-missing">— Not added</span></td>
                <td><span class="comp-date cd-missing">— Not added</span></td>
                <td class="dealer-name">—</td>
                
                <td><div class="date-val">—</div></td>
                <td><div class="date-val">19 Feb 2024</div></td>
                <td colspan="2">
                <div class="draft-progress-wrap">
                    <div class="dp-bar-track"><div class="dp-bar-fill" style="width:40%"></div></div>
                    <div class="dp-label">40%</div>
                </div>
                <div class="dp-missing">Missing: Batteries, Compliance, Dealer</div>
                <button class="btn btn-outline btn-sm" style="width:100%;justify-content:center;border-color:#ea580c;color:#ea580c" onmouseover="this.style.background='#fff7ed'" onmouseout="this.style.background=''">▶ Resume Draft</button>
                </td>
            </tr>

            </tbody>
        </table>

        <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
                        (pageChange)="paginate($event)"></app-pagination>

        <!-- <div class="table-footer">
            <div class="footer-info">Showing 1–6 of 118 · 10 per page</div>
            <div class="pagination">
            <button class="page-btn">‹</button>
            <button class="page-btn active">1</button>
            <button class="page-btn">2</button>
            <button class="page-btn">3</button>
            <button class="page-btn ellipsis">…</button>
            <button class="page-btn">12</button>
            <button class="page-btn">›</button>
            </div>
        </div> -->
        </div>

        <div style="height:24px"></div>








            </div>
        </div>
    </div>
</div>